import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

const bullets = [
  '每条内容都给出关键画面时间节点,省去在评论区找时间点。',
  '尴尬瞬间与高光瞬间分开标注,想看哪种情绪一目了然。',
  '同一分类互相链接,看完一段可以直接顺到下一段。',
];

export default function BrandStrip() {
  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div className="relative w-full h-64 md:h-[360px] rounded-lg overflow-hidden bg-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=Backstage%20dressing%20room%20with%20warm%20vanity%20bulbs%20and%20soft%20amber%20light%2C%20abstract%20costume%20racks%2C%20cozy%20blurred%20bokeh%2C%20cinematic%20editorial%20style%2C%20no%20people%2C%20warm%20neutral%20palette&width=1000&height=750&seq=gt-brand-backstage&orientation=landscape"
            alt="后台暖光化妆间的氛围图"
            title="瓜田快报 · 台前幕后的观看顺序整理"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div>
          <span className="inline-flex items-center gap-2 text-sm text-primary-700">
            <i className="ri-plant-line"></i>
            关于瓜田快报
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950">
            我们不追热点,我们整理观看顺序
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">{siteInfo.description}</p>

          <ul className="mt-6 flex flex-col gap-3">
            {bullets.map((text) => (
              <li key={text} className="flex items-start gap-3">
                <span className="mt-0.5 w-6 h-6 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-check-line"></i>
                </span>
                <span className="text-sm leading-relaxed text-foreground-700">{text}</span>
              </li>
            ))}
          </ul>

          <Link
            to="/about"
            className="mt-7 inline-flex px-5 py-2.5 rounded-md text-sm whitespace-nowrap bg-secondary-500 text-foreground-950 hover:bg-secondary-600 transition-colors cursor-pointer"
          >
            了解我们的内容原则
          </Link>
        </div>
      </div>
    </section>
  );
}